<template>
  <div class="watermark">TEST SERVER</div>
</template>

<style scoped>
.watermark {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  font-size: 100px;
  color: rgba(255, 0, 0, 0.1);
  z-index: 9999;
  pointer-events: none;
  user-select: none;
}

/* Styles for screen */
@media screen {
  .watermark {
    position: absolute;
  }
}

/* Styles for print */
@media print {
  .watermark {
    position: fixed;
  }
}
</style>
